import { Box, Grid } from '@mui/material';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { filterOptionLabel } from 'pages/globals/global';
import ProcessRoleExclUpload from './ProcessRoleExelUpload';
import { useLocation, useNavigate } from 'react-router-dom';
import comptroller from 'assets/images/comptroller_white.svg';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CustomInputLabel from 'components/Label/CustomInputLabel';
import { Button, Col, Flex, Form, Row, Select, Tabs } from 'antd';
import DetailPageHeader from 'components/header/DetailPageHeader';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import { useGetLynFormPropertyMutation, useGetSingleIdentityMutation } from 'store/features/process/processApi';
import createTabsSx from '../common/createTabsSx';

const Create = () => {
	const theme = useTheme();
	const { state } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [activate, setActivate] = useState(true);
	const [modalInfo, setModalInfo] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [counter, setCounter] = useState({
		typeC: 0,
		valueC: 0,
		positionC: 0,
	});
	const { positionC, typeC, valueC } = counter;

	const { profileData } = useSelector((state) => state?.profile);

	const [GetSingleSpacialCase, { error: errorData, isSuccess: isSingleCaseSuccess, isError: isSingleCaseError }] = useGetSingleIdentityMutation();

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed.', toastConfig);
			navigate(-1);
		}
		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
			setSubmitData(null);
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	useEffect(() => {
		if (typeC === 1 || positionC === 1 || valueC === 1) {
			setActivate(false);
		} else {
			setActivate(true);
		}
	}, [counter]);

	const onFieldsChange = (e) => {
		if (e[0]?.name[0] === 'positionCode') {
			if (e[0]?.value !== '') {
				setCounter({
					...counter,
					positionC: 1,
				});
			} else {
				setCounter({
					...counter,
					positionC: 0,
				});
			}
		} else if (e[0]?.name[0] === 'PROPERTY_assignType') {
			if (e[0]?.value !== undefined) {
				setCounter({
					...counter,
					typeC: 1,
				});
			} else {
				setCounter({
					...counter,
					typeC: 0,
				});
			}
		} else if (e[0]?.name[0] === 'assignValue') {
			if (e[0]?.value !== undefined) {
				setCounter({
					...counter,
					valueC: 1,
				});
			} else {
				setCounter({
					...counter,
					valueC: 0,
				});
			}
		}
	};

	const onModalOkHandler = () => {
		const { ...rest } = submitData;

		const payload = {
			companyCode: profileData?.creatorOrganizationId,
			...rest,
		};

		GetSingleSpacialCase({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: payload,
		});
	};

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);
		setModalInfo({
			head: 'Process Role Master',
			action: 'submit',
		});
	};

	const childrenOne = (
		<Form
			form={form}
			id="create-process-roles"
			onFieldsChange={onFieldsChange}
			layout="vertical"
			onFinish={handleModalSubmit}
			requiredMark={false}
		>
			<AntdValuePreview form={form} show={false} />

			<Row gutter={[16, 0]}>
				<Col xs={24} md={8} lg={6}>
					<CustomInputLabel label="Process Role Name" head={true} />
				</Col>
				<Col xs={24} sm={24} md={16} xl={18}>
					<CustomTextInput
						form={form}
						name="positionCode"
						placeholder="Enter process role name"
						rules={[
							{
								required: true,
								type: String,
							},
						]}
					/>
				</Col>

				<Col xs={24} md={8} lg={6}>
					<CustomInputLabel label="Assignment Type" head={true} />
				</Col>
				<Col xs={24} sm={24} md={16} xl={18}>
					<AssignmentTypeSelect code="PROPERTY_assignType" />
					<Form.Item name="assignTypeHidden" noStyle />
					<Form.Item name="assignTypeLabel" noStyle />
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						shouldUpdate={(prevValues, currentValues) => prevValues.PROPERTY_assignType !== currentValues.PROPERTY_assignType}
						style={{ marginBottom: 0 }}
					>
						{({ getFieldValue }) => (
							<>
								{getFieldValue('PROPERTY_assignType') === 'PROPERTY_assignType_fixedAssignmentByProcess' && (
									<Row gutter={[16, 0]}>
										<Col xs={24} md={8} lg={6}>
											<CustomInputLabel label="Position ID" head={true} />
										</Col>
										<Col xs={24} sm={24} md={16} xl={18}>
											<AssignmentTypeListSelect
												name="DATA_processRolePositions"
												label="Position ID"
												code="processRolePositions"
											/>
										</Col>
									</Row>
								)}
								{getFieldValue('PROPERTY_assignType') === 'PROPERTY_assignType_tempAssignmentByPractice' && (
									<Row gutter={[16, 0]}>
										<Col xs={24} md={8} lg={6}>
											<CustomInputLabel label="Employee ID" head={true} />
										</Col>
										<Col xs={24} sm={24} md={16} xl={18}>
											<AssignmentTypeListSelect
												label="Employee ID"
												code="processRoleUsers"
												style={{ marginBottom: 0 }}
												name="DATA_processRoleUsers"
											/>
										</Col>
									</Row>
								)}
							</>
						)}
					</Form.Item>
				</Col>
			</Row>
			<Flex style={{ marginTop: '10px' }} justify="flex-end" align="flex-end">
				<Button
					className={`${!activate ? 'animated-button' : ''}`}
					disabled={activate}
					style={{
						backgroundColor: activate ? '' : theme.palette.lynTheme.submit,
					}}
					type="primary"
					htmlType="submit"
				>
					Submit
				</Button>
			</Flex>
		</Form>
	);

	const items = [
		{
			key: '1',
			label: 'Single Entry',
			children: childrenOne,
		},
		{
			key: '2',
			label: 'Bulk Entry',
			children: <ProcessRoleExclUpload processCode={state?.processCode} profileData={profileData} processVersion={state?.processVersion} />,
		},
	];

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<DetailPageHeader title={`Create ${state?.processName}`} />

				<MainCard>
					<Box sx={createTabsSx}>
						<Tabs defaultActiveKey="1" items={items} tabBarGutter={0} />
					</Box>
				</MainCard>

				{showModal && (
					<ComptrollerConfirmModal
						showModal={showModal}
						setShowModal={setShowModal}
						modalData={modalInfo}
						handleSubmit={onModalOkHandler}
					/>
				)}
			</Grid>
		</Grid>
	);
};

export default Create;

export const AssignmentTypeSelect = ({ label, code, name, disabled }) => {
	const form = Form.useFormInstance();
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onAssignmentTypeHandler = (value, obj) => {
		if (value === 'PROPERTY_assignType_fixedAssignmentByProcess') {
			form.setFieldValue('DATA_processRoleUsers');
			form.setFieldValue('assignTypeHidden', 'POSITION');
		} else if (value === 'PROPERTY_assignType_tempAssignmentByPractice') {
			form.setFieldValue('DATA_processRolePositions');
			form.setFieldValue('assignTypeHidden', 'USER');
		}

		form.setFieldValue('assignValue');
		if (obj?.children) form.setFieldValue('assignTypeLabel', obj?.children);
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		}
	}, [code]);

	return (
		<CustomSelectInput
			form={form}
			disabled={disabled}
			label={label}
			name="PROPERTY_assignType"
			filterOption={filterOptionLabel}
			onSelect={onAssignmentTypeHandler}
			value={lynProperty?.lynProperties?.find((item) => item?.propertyValue === form.getFieldValue(name))?.displayName}
			rules={[
				{
					required: true,
					message: 'Assignment Type is required.',
				},
			]}
		>
			{lynProperty?.lynProperties?.map((value, index) => (
				<Select.Option key={index} value={value?.propertyValue}>
					{value?.displayName}
				</Select.Option>
			))}
		</CustomSelectInput>
	);
};

export const AssignmentTypeListSelect = ({ label, name, disabled, code, style }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();

	const onAssignmentTypeListHandler = (value) => {
		form.setFieldValue('assignValue', value);
	};

	useEffect(() => {
		if (code && userId) {
			GetLynFormData({
				name: code,
				userId,
			});
		}
	}, [code, userId]);

	return (
		<>
			<CustomSelectInput
				name={name}
				style={style}
				label={label ?? ''}
				disabled={disabled}
				filterOption={filterOptionLabel}
				onSelect={onAssignmentTypeListHandler}
				value={lynFormData?.results?.find((item) => item?.propertyValue === form.getFieldValue(name))?.displayName}
				rules={[
					{
						required: true,
					},
				]}
			>
				{lynFormData?.results?.map((value, index) => (
					<Select.Option key={index} value={value?.propertyValue}>
						{value?.displayName}
					</Select.Option>
				))}
			</CustomSelectInput>
			<Form.Item name="assignValue" noStyle />
		</>
	);
};
